<i18n src="../resources/locales.json"></i18n>
<template>
  <v-container>
    <h4>{{ $t('helpYou') }}</h4>
    <v-row v-for="bp in businessProcesses" :key="bp" class="business-process">
      <v-btn x-large dark block depressed color="custom-primary" :id="'bp-' + bp">
        {{ $t('businessProcess', { bp }) }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EcsBusinessProcess',
  props: {
    businessProcesses: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.business-process {
  margin: 24px 0;
}
</style>
